
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as aboutOS7HpsGFDFSTbbd4iXDP92Iuvckam0GQw5dgZEXCgBIMeta } from "/vercel/path0/pages/about.vue?macro=true";
import { default as account_45typesKerh6PoWCItJFrVQVtSzYzYYJgkM0K1tvDmDHdNN1goMeta } from "/vercel/path0/pages/account-types.vue?macro=true";
import { default as affiliatevueozIzX9FSBJULheRnZvU0ak_2nwCdA_X0MReNX7G4Meta } from "/vercel/path0/pages/affiliate.vue?macro=true";
import { default as appDmcDqKB_UUcMqbnh5mZnO1Oc_lioEvOI5YIfab9cXBsMeta } from "/vercel/path0/pages/app.vue?macro=true";
import { default as careersBNx22yphzVH69_WOQ9R_45t5R5v9s8hxkEbkAtyNZSxJcMeta } from "/vercel/path0/pages/careers.vue?macro=true";
import { default as cfd_45asset_45listiXW_45JBafCrVMzD3RiHpEsqUTSYvWKIzX6Cy0K1syaPgMeta } from "/vercel/path0/pages/cfd-asset-list.vue?macro=true";
import { default as cfd_45tradingDXb_pxjeC1zUZ1JnpRklXz4ZVyDw3lAo_bcOtBehPisMeta } from "/vercel/path0/pages/cfd-trading.vue?macro=true";
import { default as commoditieseVJNWLmMRaBhsN0OXC4aD01ETZDl_ADTRw8fPGe55VQMeta } from "/vercel/path0/pages/commodities.vue?macro=true";
import { default as contact6cZoOGxJBTY9l_45DSf37OWQKprIBU1PffJx7PVn14dCsMeta } from "/vercel/path0/pages/contact.vue?macro=true";
import { default as cookie_45disclosurez0wIkPjBd4g6jhBxxN3DwBA9o4Aw8gS2I45pesUMohUMeta } from "/vercel/path0/pages/cookie-disclosure.vue?macro=true";
import { default as copy_45trading_M4ULVVO1TtofQkIHMckM3sS_45eTtRBltzIGmp9FpWl8Meta } from "/vercel/path0/pages/copy-trading.vue?macro=true";
import { default as cryptovwNulGBclU4TmtF_45O9K8bhnqGSwXVNWIDYaNDdJjpUwMeta } from "/vercel/path0/pages/crypto.vue?macro=true";
import { default as _91slug_93KS64wKg7lZ8PGgUOhkDz4mx4nTU5_dgGJJGP613N7Z8Meta } from "/vercel/path0/pages/education-authors/[slug].vue?macro=true";
import { default as _91slug_93aOw9xJtq_45PwNFG8wokcQZVrt25Ck5wyrxcoLUNwfscwMeta } from "/vercel/path0/pages/education-category/[slug].vue?macro=true";
import { default as education_45centerafSvuhpyKcNNKib49leJdQfaSpT7fjRDp573eMqKRCoMeta } from "/vercel/path0/pages/education-center.vue?macro=true";
import { default as _91slug_93ldQxIDzzAlotg8XYLaZBUWh4gof5v97SYb757vp89PMMeta } from "/vercel/path0/pages/education-tags/[slug].vue?macro=true";
import { default as _91slug_93diQoYirR20EpqUvxjsYl8V2gjwJpG_iJYtOPLn8T3agMeta } from "/vercel/path0/pages/education/[slug].vue?macro=true";
import { default as errorN_45ENTyPlpzPg6hn_0BxpsMhhH7pcBYCZkt9W5qJyQFYMeta } from "/vercel/path0/pages/error.vue?macro=true";
import { default as faqs9MPJhR40d_457SYFvRdFNEUKOTFEuH4KyHmCs_3uSJ_45CQMeta } from "/vercel/path0/pages/faqs.vue?macro=true";
import { default as forexYIfKBqzk_qTXDwfcu_0DNfNDIt07j9sCOwFJgHcXgdAMeta } from "/vercel/path0/pages/forex.vue?macro=true";
import { default as forgot_45passwordYJWD0lcAfYaJTH90StowtOH8csR4uDHd8I_HNp6CgXIMeta } from "/vercel/path0/pages/forgot-password.vue?macro=true";
import { default as glossaryLnYlMEMZclBGDCxDgV3uo1_UMtSJjaZNwPJ5uj1wGzUMeta } from "/vercel/path0/pages/glossary.vue?macro=true";
import { default as ibtfH0sbPDpKWZiUjWtHBbJKo4AtrlzQY6etTZ2O9ZxNcMeta } from "/vercel/path0/pages/ib.vue?macro=true";
import { default as indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as indicesfL1WrgF6qIFsXDUrDEiLGt4Hz7PVDeEHAihfJ3W_YlcMeta } from "/vercel/path0/pages/indices.vue?macro=true";
import { default as _91slug_93LE3SAiXDaG24uMxrDXhRKokIEmTFq4ca_45jCQXdTgRlsMeta } from "/vercel/path0/pages/job-post/[slug].vue?macro=true";
import { default as loginyiubrZraL9EDD3J38Z_45ftLpCUym9OoYm1Hb9453rWnMMeta } from "/vercel/path0/pages/login.vue?macro=true";
import { default as mt5d2XwimgrR_45rBEhiVN9_0qPEnZ4oWFRJrNwksLCBUImcMeta } from "/vercel/path0/pages/mt5.vue?macro=true";
import { default as _91slug_939CWxqIOx5iOCMzhZkMCVDCWX_sbgOacBo_45pjzikFCcYMeta } from "/vercel/path0/pages/news-category/[slug].vue?macro=true";
import { default as indexBO48T73vzelG8jBQp_sS6EwaZ8Sp0dQso5wmZ7tcHpMMeta } from "/vercel/path0/pages/news-center/index.vue?macro=true";
import { default as _91_91id_93_93NzUx0MwDPfUSzuQCfLzCvQ_45p0NMk62C_P2YeYOFg0zcMeta } from "/vercel/path0/pages/news-center/news/[[id]].vue?macro=true";
import { default as _91slug_93n4WroOo_88nWrszyGmhdC7ysQnNkb4dMZ5SsWPwe2vwMeta } from "/vercel/path0/pages/news-tags/[slug].vue?macro=true";
import { default as _91slug_93zV20cmb7itauD9tpNOFSMl52lkTFbrLCBVcRbZx5yfUMeta } from "/vercel/path0/pages/news/[slug].vue?macro=true";
import { default as old_45registerxsrmdqaLDu9Ztx7djw0bVK2GTHwPz_CKk7_459a66MrmwMeta } from "/vercel/path0/pages/old-register.vue?macro=true";
import { default as partnersJ1xnWJo82AcJWgQT7Pfhn0SRmtm3gYh8Ih7yXCpnTQsMeta } from "/vercel/path0/pages/partners.vue?macro=true";
import { default as privacy_45policy4XTtqETNZShW4bt4tv1KYsHRfQDwaNm0MGXT0dxQJr0Meta } from "/vercel/path0/pages/privacy-policy.vue?macro=true";
import { default as registerYVQw2hrVHVB4lGWKPyo5FmqMHpKgdBVJqzomEM8zf3IMeta } from "/vercel/path0/pages/register.vue?macro=true";
import { default as regulation6YJLdiemdCRkI2QR7dDxAsPH3ix2vylcfclHtJ7eTlIMeta } from "/vercel/path0/pages/regulation.vue?macro=true";
import { default as stocksdyR4riUiCOzYWuTwTOS7E5eBxNnMwUYwpWeqNHAslVgMeta } from "/vercel/path0/pages/stocks.vue?macro=true";
import { default as tagso8aEOVtdD7W4VEEW_uxsc8_O4TWXlHEYzeXMfRC5qF4Meta } from "/vercel/path0/pages/tags.vue?macro=true";
import { default as trading_45basicsRnggC_5zqVKLwdAkzANqKxt6_vNnVebAI2dQVLnItM8Meta } from "/vercel/path0/pages/trading-basics.vue?macro=true";
import { default as trading_45hours85APllXXEX3oppjdqfWGhhgT5ymxs_45Yz92D3qGKoJWMMeta } from "/vercel/path0/pages/trading-hours.vue?macro=true";
import { default as trading_45toolsQUZRP3T9Tegk3oqwxbfyLcKNpwwam06ue8Ikhic8vFQMeta } from "/vercel/path0/pages/trading-tools.vue?macro=true";
import { default as webtraderAeUUBhUsySWbRGv9AH8rXDkw6EgxiOE60WMbaJbSXtwMeta } from "/vercel/path0/pages/webtrader.vue?macro=true";
import { default as why_45ussqXMG9Hy9LRVLcaLZwqmtYTk3nv0C_45P7GmEG0i8mpsAMeta } from "/vercel/path0/pages/why-us.vue?macro=true";
export default [
  {
    name: "about___en___default",
    path: "/about",
    component: () => import("/vercel/path0/pages/about.vue")
  },
  {
    name: "about___en",
    path: "/en/about",
    component: () => import("/vercel/path0/pages/about.vue")
  },
  {
    name: "about___es",
    path: "/es/about",
    component: () => import("/vercel/path0/pages/about.vue")
  },
  {
    name: "about___it",
    path: "/it/about",
    component: () => import("/vercel/path0/pages/about.vue")
  },
  {
    name: "account-types___en___default",
    path: "/account-types",
    component: () => import("/vercel/path0/pages/account-types.vue")
  },
  {
    name: "account-types___en",
    path: "/en/account-types",
    component: () => import("/vercel/path0/pages/account-types.vue")
  },
  {
    name: "account-types___es",
    path: "/es/account-types",
    component: () => import("/vercel/path0/pages/account-types.vue")
  },
  {
    name: "account-types___it",
    path: "/it/account-types",
    component: () => import("/vercel/path0/pages/account-types.vue")
  },
  {
    name: "affiliate___en___default",
    path: "/affiliate",
    component: () => import("/vercel/path0/pages/affiliate.vue")
  },
  {
    name: "affiliate___en",
    path: "/en/affiliate",
    component: () => import("/vercel/path0/pages/affiliate.vue")
  },
  {
    name: "affiliate___es",
    path: "/es/affiliate",
    component: () => import("/vercel/path0/pages/affiliate.vue")
  },
  {
    name: "affiliate___it",
    path: "/it/affiliate",
    component: () => import("/vercel/path0/pages/affiliate.vue")
  },
  {
    name: "app___en___default",
    path: "/app",
    component: () => import("/vercel/path0/pages/app.vue")
  },
  {
    name: "app___en",
    path: "/en/app",
    component: () => import("/vercel/path0/pages/app.vue")
  },
  {
    name: "app___es",
    path: "/es/app",
    component: () => import("/vercel/path0/pages/app.vue")
  },
  {
    name: "app___it",
    path: "/it/app",
    component: () => import("/vercel/path0/pages/app.vue")
  },
  {
    name: "careers___en___default",
    path: "/careers",
    component: () => import("/vercel/path0/pages/careers.vue")
  },
  {
    name: "careers___en",
    path: "/en/careers",
    component: () => import("/vercel/path0/pages/careers.vue")
  },
  {
    name: "careers___es",
    path: "/es/careers",
    component: () => import("/vercel/path0/pages/careers.vue")
  },
  {
    name: "careers___it",
    path: "/it/careers",
    component: () => import("/vercel/path0/pages/careers.vue")
  },
  {
    name: "cfd-asset-list___en___default",
    path: "/cfd-asset-list",
    component: () => import("/vercel/path0/pages/cfd-asset-list.vue")
  },
  {
    name: "cfd-asset-list___en",
    path: "/en/cfd-asset-list",
    component: () => import("/vercel/path0/pages/cfd-asset-list.vue")
  },
  {
    name: "cfd-asset-list___es",
    path: "/es/cfd-asset-list",
    component: () => import("/vercel/path0/pages/cfd-asset-list.vue")
  },
  {
    name: "cfd-asset-list___it",
    path: "/it/cfd-asset-list",
    component: () => import("/vercel/path0/pages/cfd-asset-list.vue")
  },
  {
    name: "cfd-trading___en___default",
    path: "/cfd-trading",
    component: () => import("/vercel/path0/pages/cfd-trading.vue")
  },
  {
    name: "cfd-trading___en",
    path: "/en/cfd-trading",
    component: () => import("/vercel/path0/pages/cfd-trading.vue")
  },
  {
    name: "cfd-trading___es",
    path: "/es/cfd-trading",
    component: () => import("/vercel/path0/pages/cfd-trading.vue")
  },
  {
    name: "cfd-trading___it",
    path: "/it/cfd-trading",
    component: () => import("/vercel/path0/pages/cfd-trading.vue")
  },
  {
    name: "commodities___en___default",
    path: "/commodities",
    component: () => import("/vercel/path0/pages/commodities.vue")
  },
  {
    name: "commodities___en",
    path: "/en/commodities",
    component: () => import("/vercel/path0/pages/commodities.vue")
  },
  {
    name: "commodities___es",
    path: "/es/commodities",
    component: () => import("/vercel/path0/pages/commodities.vue")
  },
  {
    name: "commodities___it",
    path: "/it/commodities",
    component: () => import("/vercel/path0/pages/commodities.vue")
  },
  {
    name: "contact___en___default",
    path: "/contact",
    component: () => import("/vercel/path0/pages/contact.vue")
  },
  {
    name: "contact___en",
    path: "/en/contact",
    component: () => import("/vercel/path0/pages/contact.vue")
  },
  {
    name: "contact___es",
    path: "/es/contact",
    component: () => import("/vercel/path0/pages/contact.vue")
  },
  {
    name: "contact___it",
    path: "/it/contact",
    component: () => import("/vercel/path0/pages/contact.vue")
  },
  {
    name: "cookie-disclosure___en___default",
    path: "/cookie-disclosure",
    component: () => import("/vercel/path0/pages/cookie-disclosure.vue")
  },
  {
    name: "cookie-disclosure___en",
    path: "/en/cookie-disclosure",
    component: () => import("/vercel/path0/pages/cookie-disclosure.vue")
  },
  {
    name: "cookie-disclosure___es",
    path: "/es/cookie-disclosure",
    component: () => import("/vercel/path0/pages/cookie-disclosure.vue")
  },
  {
    name: "cookie-disclosure___it",
    path: "/it/cookie-disclosure",
    component: () => import("/vercel/path0/pages/cookie-disclosure.vue")
  },
  {
    name: "copy-trading___en___default",
    path: "/copy-trading",
    component: () => import("/vercel/path0/pages/copy-trading.vue")
  },
  {
    name: "copy-trading___en",
    path: "/en/copy-trading",
    component: () => import("/vercel/path0/pages/copy-trading.vue")
  },
  {
    name: "copy-trading___es",
    path: "/es/copy-trading",
    component: () => import("/vercel/path0/pages/copy-trading.vue")
  },
  {
    name: "copy-trading___it",
    path: "/it/copy-trading",
    component: () => import("/vercel/path0/pages/copy-trading.vue")
  },
  {
    name: "crypto___en___default",
    path: "/crypto",
    component: () => import("/vercel/path0/pages/crypto.vue")
  },
  {
    name: "crypto___en",
    path: "/en/crypto",
    component: () => import("/vercel/path0/pages/crypto.vue")
  },
  {
    name: "crypto___es",
    path: "/es/crypto",
    component: () => import("/vercel/path0/pages/crypto.vue")
  },
  {
    name: "crypto___it",
    path: "/it/crypto",
    component: () => import("/vercel/path0/pages/crypto.vue")
  },
  {
    name: "education-authors-slug___en___default",
    path: "/education-authors/:slug()",
    component: () => import("/vercel/path0/pages/education-authors/[slug].vue")
  },
  {
    name: "education-authors-slug___en",
    path: "/en/education-authors/:slug()",
    component: () => import("/vercel/path0/pages/education-authors/[slug].vue")
  },
  {
    name: "education-authors-slug___es",
    path: "/es/education-authors/:slug()",
    component: () => import("/vercel/path0/pages/education-authors/[slug].vue")
  },
  {
    name: "education-authors-slug___it",
    path: "/it/education-authors/:slug()",
    component: () => import("/vercel/path0/pages/education-authors/[slug].vue")
  },
  {
    name: "education-category-slug___en___default",
    path: "/education-category/:slug()",
    component: () => import("/vercel/path0/pages/education-category/[slug].vue")
  },
  {
    name: "education-category-slug___en",
    path: "/en/education-category/:slug()",
    component: () => import("/vercel/path0/pages/education-category/[slug].vue")
  },
  {
    name: "education-category-slug___es",
    path: "/es/education-category/:slug()",
    component: () => import("/vercel/path0/pages/education-category/[slug].vue")
  },
  {
    name: "education-category-slug___it",
    path: "/it/education-category/:slug()",
    component: () => import("/vercel/path0/pages/education-category/[slug].vue")
  },
  {
    name: "education-center___en___default",
    path: "/education-center",
    component: () => import("/vercel/path0/pages/education-center.vue")
  },
  {
    name: "education-center___en",
    path: "/en/education-center",
    component: () => import("/vercel/path0/pages/education-center.vue")
  },
  {
    name: "education-center___es",
    path: "/es/education-center",
    component: () => import("/vercel/path0/pages/education-center.vue")
  },
  {
    name: "education-center___it",
    path: "/it/education-center",
    component: () => import("/vercel/path0/pages/education-center.vue")
  },
  {
    name: "education-tags-slug___en___default",
    path: "/education-tags/:slug()",
    component: () => import("/vercel/path0/pages/education-tags/[slug].vue")
  },
  {
    name: "education-tags-slug___en",
    path: "/en/education-tags/:slug()",
    component: () => import("/vercel/path0/pages/education-tags/[slug].vue")
  },
  {
    name: "education-tags-slug___es",
    path: "/es/education-tags/:slug()",
    component: () => import("/vercel/path0/pages/education-tags/[slug].vue")
  },
  {
    name: "education-tags-slug___it",
    path: "/it/education-tags/:slug()",
    component: () => import("/vercel/path0/pages/education-tags/[slug].vue")
  },
  {
    name: "education-slug___en___default",
    path: "/education/:slug()",
    component: () => import("/vercel/path0/pages/education/[slug].vue")
  },
  {
    name: "education-slug___en",
    path: "/en/education/:slug()",
    component: () => import("/vercel/path0/pages/education/[slug].vue")
  },
  {
    name: "education-slug___es",
    path: "/es/education/:slug()",
    component: () => import("/vercel/path0/pages/education/[slug].vue")
  },
  {
    name: "education-slug___it",
    path: "/it/education/:slug()",
    component: () => import("/vercel/path0/pages/education/[slug].vue")
  },
  {
    name: "error___en___default",
    path: "/error",
    component: () => import("/vercel/path0/pages/error.vue")
  },
  {
    name: "error___en",
    path: "/en/error",
    component: () => import("/vercel/path0/pages/error.vue")
  },
  {
    name: "error___es",
    path: "/es/error",
    component: () => import("/vercel/path0/pages/error.vue")
  },
  {
    name: "error___it",
    path: "/it/error",
    component: () => import("/vercel/path0/pages/error.vue")
  },
  {
    name: "faqs___en___default",
    path: "/faqs",
    component: () => import("/vercel/path0/pages/faqs.vue")
  },
  {
    name: "faqs___en",
    path: "/en/faqs",
    component: () => import("/vercel/path0/pages/faqs.vue")
  },
  {
    name: "faqs___es",
    path: "/es/faqs",
    component: () => import("/vercel/path0/pages/faqs.vue")
  },
  {
    name: "faqs___it",
    path: "/it/faqs",
    component: () => import("/vercel/path0/pages/faqs.vue")
  },
  {
    name: "forex___en___default",
    path: "/forex",
    component: () => import("/vercel/path0/pages/forex.vue")
  },
  {
    name: "forex___en",
    path: "/en/forex",
    component: () => import("/vercel/path0/pages/forex.vue")
  },
  {
    name: "forex___es",
    path: "/es/forex",
    component: () => import("/vercel/path0/pages/forex.vue")
  },
  {
    name: "forex___it",
    path: "/it/forex",
    component: () => import("/vercel/path0/pages/forex.vue")
  },
  {
    name: "forgot-password___en___default",
    path: "/forgot-password",
    component: () => import("/vercel/path0/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___en",
    path: "/en/forgot-password",
    component: () => import("/vercel/path0/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___es",
    path: "/es/forgot-password",
    component: () => import("/vercel/path0/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___it",
    path: "/it/forgot-password",
    component: () => import("/vercel/path0/pages/forgot-password.vue")
  },
  {
    name: "glossary___en___default",
    path: "/glossary",
    component: () => import("/vercel/path0/pages/glossary.vue")
  },
  {
    name: "glossary___en",
    path: "/en/glossary",
    component: () => import("/vercel/path0/pages/glossary.vue")
  },
  {
    name: "glossary___es",
    path: "/es/glossary",
    component: () => import("/vercel/path0/pages/glossary.vue")
  },
  {
    name: "glossary___it",
    path: "/it/glossary",
    component: () => import("/vercel/path0/pages/glossary.vue")
  },
  {
    name: "ib___en___default",
    path: "/ib",
    component: () => import("/vercel/path0/pages/ib.vue")
  },
  {
    name: "ib___en",
    path: "/en/ib",
    component: () => import("/vercel/path0/pages/ib.vue")
  },
  {
    name: "ib___es",
    path: "/es/ib",
    component: () => import("/vercel/path0/pages/ib.vue")
  },
  {
    name: "ib___it",
    path: "/it/ib",
    component: () => import("/vercel/path0/pages/ib.vue")
  },
  {
    name: "index___en___default",
    path: "/",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "index___it",
    path: "/it",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "indices___en___default",
    path: "/indices",
    component: () => import("/vercel/path0/pages/indices.vue")
  },
  {
    name: "indices___en",
    path: "/en/indices",
    component: () => import("/vercel/path0/pages/indices.vue")
  },
  {
    name: "indices___es",
    path: "/es/indices",
    component: () => import("/vercel/path0/pages/indices.vue")
  },
  {
    name: "indices___it",
    path: "/it/indices",
    component: () => import("/vercel/path0/pages/indices.vue")
  },
  {
    name: "job-post-slug___en___default",
    path: "/job-post/:slug()",
    component: () => import("/vercel/path0/pages/job-post/[slug].vue")
  },
  {
    name: "job-post-slug___en",
    path: "/en/job-post/:slug()",
    component: () => import("/vercel/path0/pages/job-post/[slug].vue")
  },
  {
    name: "job-post-slug___es",
    path: "/es/job-post/:slug()",
    component: () => import("/vercel/path0/pages/job-post/[slug].vue")
  },
  {
    name: "job-post-slug___it",
    path: "/it/job-post/:slug()",
    component: () => import("/vercel/path0/pages/job-post/[slug].vue")
  },
  {
    name: "login___en___default",
    path: "/login",
    component: () => import("/vercel/path0/pages/login.vue")
  },
  {
    name: "login___en",
    path: "/en/login",
    component: () => import("/vercel/path0/pages/login.vue")
  },
  {
    name: "login___es",
    path: "/es/login",
    component: () => import("/vercel/path0/pages/login.vue")
  },
  {
    name: "login___it",
    path: "/it/login",
    component: () => import("/vercel/path0/pages/login.vue")
  },
  {
    name: "mt5___en___default",
    path: "/mt5",
    component: () => import("/vercel/path0/pages/mt5.vue")
  },
  {
    name: "mt5___en",
    path: "/en/mt5",
    component: () => import("/vercel/path0/pages/mt5.vue")
  },
  {
    name: "mt5___es",
    path: "/es/mt5",
    component: () => import("/vercel/path0/pages/mt5.vue")
  },
  {
    name: "mt5___it",
    path: "/it/mt5",
    component: () => import("/vercel/path0/pages/mt5.vue")
  },
  {
    name: "news-category-slug___en___default",
    path: "/news-category/:slug()",
    component: () => import("/vercel/path0/pages/news-category/[slug].vue")
  },
  {
    name: "news-category-slug___en",
    path: "/en/news-category/:slug()",
    component: () => import("/vercel/path0/pages/news-category/[slug].vue")
  },
  {
    name: "news-category-slug___es",
    path: "/es/news-category/:slug()",
    component: () => import("/vercel/path0/pages/news-category/[slug].vue")
  },
  {
    name: "news-category-slug___it",
    path: "/it/news-category/:slug()",
    component: () => import("/vercel/path0/pages/news-category/[slug].vue")
  },
  {
    name: "news-center___en___default",
    path: "/news-center",
    component: () => import("/vercel/path0/pages/news-center/index.vue")
  },
  {
    name: "news-center___en",
    path: "/en/news-center",
    component: () => import("/vercel/path0/pages/news-center/index.vue")
  },
  {
    name: "news-center___es",
    path: "/es/news-center",
    component: () => import("/vercel/path0/pages/news-center/index.vue")
  },
  {
    name: "news-center___it",
    path: "/it/news-center",
    component: () => import("/vercel/path0/pages/news-center/index.vue")
  },
  {
    name: "news-center-news-id___en___default",
    path: "/news-center/news/:id?",
    component: () => import("/vercel/path0/pages/news-center/news/[[id]].vue")
  },
  {
    name: "news-center-news-id___en",
    path: "/en/news-center/news/:id?",
    component: () => import("/vercel/path0/pages/news-center/news/[[id]].vue")
  },
  {
    name: "news-center-news-id___es",
    path: "/es/news-center/news/:id?",
    component: () => import("/vercel/path0/pages/news-center/news/[[id]].vue")
  },
  {
    name: "news-center-news-id___it",
    path: "/it/news-center/news/:id?",
    component: () => import("/vercel/path0/pages/news-center/news/[[id]].vue")
  },
  {
    name: "news-tags-slug___en___default",
    path: "/news-tags/:slug()",
    component: () => import("/vercel/path0/pages/news-tags/[slug].vue")
  },
  {
    name: "news-tags-slug___en",
    path: "/en/news-tags/:slug()",
    component: () => import("/vercel/path0/pages/news-tags/[slug].vue")
  },
  {
    name: "news-tags-slug___es",
    path: "/es/news-tags/:slug()",
    component: () => import("/vercel/path0/pages/news-tags/[slug].vue")
  },
  {
    name: "news-tags-slug___it",
    path: "/it/news-tags/:slug()",
    component: () => import("/vercel/path0/pages/news-tags/[slug].vue")
  },
  {
    name: "news-slug___en___default",
    path: "/news/:slug()",
    component: () => import("/vercel/path0/pages/news/[slug].vue")
  },
  {
    name: "news-slug___en",
    path: "/en/news/:slug()",
    component: () => import("/vercel/path0/pages/news/[slug].vue")
  },
  {
    name: "news-slug___es",
    path: "/es/news/:slug()",
    component: () => import("/vercel/path0/pages/news/[slug].vue")
  },
  {
    name: "news-slug___it",
    path: "/it/news/:slug()",
    component: () => import("/vercel/path0/pages/news/[slug].vue")
  },
  {
    name: "old-register___en___default",
    path: "/old-register",
    component: () => import("/vercel/path0/pages/old-register.vue")
  },
  {
    name: "old-register___en",
    path: "/en/old-register",
    component: () => import("/vercel/path0/pages/old-register.vue")
  },
  {
    name: "old-register___es",
    path: "/es/old-register",
    component: () => import("/vercel/path0/pages/old-register.vue")
  },
  {
    name: "old-register___it",
    path: "/it/old-register",
    component: () => import("/vercel/path0/pages/old-register.vue")
  },
  {
    name: "partners___en___default",
    path: "/partners",
    component: () => import("/vercel/path0/pages/partners.vue")
  },
  {
    name: "partners___en",
    path: "/en/partners",
    component: () => import("/vercel/path0/pages/partners.vue")
  },
  {
    name: "partners___es",
    path: "/es/partners",
    component: () => import("/vercel/path0/pages/partners.vue")
  },
  {
    name: "partners___it",
    path: "/it/partners",
    component: () => import("/vercel/path0/pages/partners.vue")
  },
  {
    name: "privacy-policy___en___default",
    path: "/privacy-policy",
    component: () => import("/vercel/path0/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___en",
    path: "/en/privacy-policy",
    component: () => import("/vercel/path0/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___es",
    path: "/es/privacy-policy",
    component: () => import("/vercel/path0/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___it",
    path: "/it/privacy-policy",
    component: () => import("/vercel/path0/pages/privacy-policy.vue")
  },
  {
    name: "register___en___default",
    path: "/register",
    component: () => import("/vercel/path0/pages/register.vue")
  },
  {
    name: "register___en",
    path: "/en/register",
    component: () => import("/vercel/path0/pages/register.vue")
  },
  {
    name: "register___es",
    path: "/es/register",
    component: () => import("/vercel/path0/pages/register.vue")
  },
  {
    name: "register___it",
    path: "/it/register",
    component: () => import("/vercel/path0/pages/register.vue")
  },
  {
    name: "regulation___en___default",
    path: "/regulation",
    component: () => import("/vercel/path0/pages/regulation.vue")
  },
  {
    name: "regulation___en",
    path: "/en/regulation",
    component: () => import("/vercel/path0/pages/regulation.vue")
  },
  {
    name: "regulation___es",
    path: "/es/regulation",
    component: () => import("/vercel/path0/pages/regulation.vue")
  },
  {
    name: "regulation___it",
    path: "/it/regulation",
    component: () => import("/vercel/path0/pages/regulation.vue")
  },
  {
    name: "stocks___en___default",
    path: "/stocks",
    component: () => import("/vercel/path0/pages/stocks.vue")
  },
  {
    name: "stocks___en",
    path: "/en/stocks",
    component: () => import("/vercel/path0/pages/stocks.vue")
  },
  {
    name: "stocks___es",
    path: "/es/stocks",
    component: () => import("/vercel/path0/pages/stocks.vue")
  },
  {
    name: "stocks___it",
    path: "/it/stocks",
    component: () => import("/vercel/path0/pages/stocks.vue")
  },
  {
    name: "tags___en___default",
    path: "/tags",
    component: () => import("/vercel/path0/pages/tags.vue")
  },
  {
    name: "tags___en",
    path: "/en/tags",
    component: () => import("/vercel/path0/pages/tags.vue")
  },
  {
    name: "tags___es",
    path: "/es/tags",
    component: () => import("/vercel/path0/pages/tags.vue")
  },
  {
    name: "tags___it",
    path: "/it/tags",
    component: () => import("/vercel/path0/pages/tags.vue")
  },
  {
    name: "trading-basics___en___default",
    path: "/trading-basics",
    component: () => import("/vercel/path0/pages/trading-basics.vue")
  },
  {
    name: "trading-basics___en",
    path: "/en/trading-basics",
    component: () => import("/vercel/path0/pages/trading-basics.vue")
  },
  {
    name: "trading-basics___es",
    path: "/es/trading-basics",
    component: () => import("/vercel/path0/pages/trading-basics.vue")
  },
  {
    name: "trading-basics___it",
    path: "/it/trading-basics",
    component: () => import("/vercel/path0/pages/trading-basics.vue")
  },
  {
    name: "trading-hours___en___default",
    path: "/trading-hours",
    component: () => import("/vercel/path0/pages/trading-hours.vue")
  },
  {
    name: "trading-hours___en",
    path: "/en/trading-hours",
    component: () => import("/vercel/path0/pages/trading-hours.vue")
  },
  {
    name: "trading-hours___es",
    path: "/es/trading-hours",
    component: () => import("/vercel/path0/pages/trading-hours.vue")
  },
  {
    name: "trading-hours___it",
    path: "/it/trading-hours",
    component: () => import("/vercel/path0/pages/trading-hours.vue")
  },
  {
    name: "trading-tools___en___default",
    path: "/trading-tools",
    component: () => import("/vercel/path0/pages/trading-tools.vue")
  },
  {
    name: "trading-tools___en",
    path: "/en/trading-tools",
    component: () => import("/vercel/path0/pages/trading-tools.vue")
  },
  {
    name: "trading-tools___es",
    path: "/es/trading-tools",
    component: () => import("/vercel/path0/pages/trading-tools.vue")
  },
  {
    name: "trading-tools___it",
    path: "/it/trading-tools",
    component: () => import("/vercel/path0/pages/trading-tools.vue")
  },
  {
    name: "webtrader___en___default",
    path: "/webtrader",
    component: () => import("/vercel/path0/pages/webtrader.vue")
  },
  {
    name: "webtrader___en",
    path: "/en/webtrader",
    component: () => import("/vercel/path0/pages/webtrader.vue")
  },
  {
    name: "webtrader___es",
    path: "/es/webtrader",
    component: () => import("/vercel/path0/pages/webtrader.vue")
  },
  {
    name: "webtrader___it",
    path: "/it/webtrader",
    component: () => import("/vercel/path0/pages/webtrader.vue")
  },
  {
    name: "why-us___en___default",
    path: "/why-us",
    component: () => import("/vercel/path0/pages/why-us.vue")
  },
  {
    name: "why-us___en",
    path: "/en/why-us",
    component: () => import("/vercel/path0/pages/why-us.vue")
  },
  {
    name: "why-us___es",
    path: "/es/why-us",
    component: () => import("/vercel/path0/pages/why-us.vue")
  },
  {
    name: "why-us___it",
    path: "/it/why-us",
    component: () => import("/vercel/path0/pages/why-us.vue")
  }
]